import { boolean, InferType, object } from "yup";

export const CampaignEnrolmentSchema = object({
  acceptedTerms: boolean().oneOf([true], "You must accept the terms and conditions")
});

export interface CampaignEnrolmentValues extends InferType<typeof CampaignEnrolmentSchema> {}